import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import SysConfigStore from '../../store/common/SysConfigStore';
import ButtonLoading from '../ui/buttons/ButtonLoading';
import { PopupCommonExternalProps } from '../ui/popups/PopupCommonExternal';
import PopupSuccess from '../ui/popups/PopupSuccess';

type Props = PopupCommonExternalProps & {
	loading?: boolean;
	setOpen: Dispatch<SetStateAction<boolean>>;
};

export default function PopupSignSuccess({ loading, open, setOpen, onConfirm, ...props }: Props) {
	const { labelText } = SysConfigStore();
	const { t } = useTranslation();
	const handleClose = () => setOpen(false);
	const handleConfirm = () => {
		if (typeof onConfirm === 'function') {
			onConfirm();
		}
	};

	return (
		<>
			<ButtonLoading
				loading={loading}
				variant='contained'
				text={t('electronic_seal_completion').replace('{{날인}}', labelText('seal'))}
				color='primary'
				onClick={() => setOpen(true)}
			/>
			<PopupSuccess
				size='xsmall'
				open={open}
				loading={loading}
				onConfirm={handleConfirm}
				onCancel={handleClose}
				onClose={handleClose}
				{...props}
			/>
		</>
	);
}
